export const ScoreType = {
    HEAD2HEAD: 0,
    HEAD2HEADWITHOT: 1,
    PERPERIOD: 2,
    PERPERIODWITHOT: 3,
    FTONLY: 4,
    FTONLYWITHOT: 5
};